<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="image">For my grandmother and staunchest<br/>supporter, Leokadjia “Lillian” B. Kelley,<br/>whose indomitable strength came<br/>at such a high cost</p>
<p class="image"><a id="page_vii"></a><img alt="Images" src="images/f0vii-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?945184b6